module.exports = __webpack_public_path__ + "static/median-time-desktop-ea45a6f4a924f92ea4c1713cd9bfdfd9.png";